const styles = theme => ({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center"
  },
  "&>react-swipeable-view-container": {
    background: "pink"
  },
  container: {
    height: "100%",
    background: "white",
    [theme.breakpoints.down("sm")]: {
      paddingTop: 20,
      paddingBottom: 80,
      paddingLeft: 20,
      paddingRight: 20,
      "@supports (padding-bottom: constant(safe-area-inset-bottom))": {
        "--safe-area-inset-bottom": "constant(safe-area-inset-bottom)",
        "--safe-area-inset-top": "constant(safe-area-inset-top)",
        paddingBottom: "calc(80px + var(--safe-area-inset-bottom))",
        paddingTop: "calc(20px + var(--safe-area-inset-top))"
      },
      "@supports (padding-bottom: env(safe-area-inset-bottom))": {
        "--safe-area-inset-bottom": "env(safe-area-inset-bottom)",
        "--safe-area-inset-top": "env(safe-area-inset-top)",
        paddingBottom: "calc(80px + var(--safe-area-inset-bottom))",
        paddingTop: "calc(20px + var(--safe-area-inset-top))"
      }
    }
  },
  contentContainer: {
    position: "relative",
    flex: 1
  },
  stepContainer: {
    margi: "0 auto",
    width: "300px"
  },
  circle: {
    background: theme.palette.alt.main,
    width: 16,
    height: 16,
    borderRadius: "50%",
    transition: "width .3s ease-out",
    cursor: "pointer"
  },
  active: {
    width: 32,
    borderRadius: 8,
    cursor: "pointer"
  },
  nextButton: {
    width: "50%",
    height: "60px",
    backgroundColor: theme.palette.primary.default,
    color: "#fff!important",
    "&:hover": {
      backgroundColor: theme.palette.primary.default
    }
  },
  backButton: {
    width: "50%",
    height: "60px",
    backgroundColor: "#fff",
    color: theme.palette.primary.light,
    "&:hover": {
      backgroundColor: "#fff"
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/OnBoarding/styles.js